import { render } from "./ghabghabmoraghebat.vue?vue&type=template&id=2bc3201b"
import script from "./ghabghabmoraghebat.vue?vue&type=script&lang=js"
export * from "./ghabghabmoraghebat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__